import React from 'react';
import { Modal, Form, Input, DatePicker, InputNumber, Select } from 'antd';
import { CreatePartnerRequest } from '../../model/Partner.model';
import dayjs from 'dayjs';

interface PartnerCreateModalProps {
  open: boolean;
  loading: boolean;
  onOk: (values: CreatePartnerRequest) => void;
  onCancel: () => void;
}

const PartnerCreateModal: React.FC<PartnerCreateModalProps> = ({
  open,
  loading,
  onOk,
  onCancel,
}) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const formattedValues: CreatePartnerRequest = {
        ...values,
        registrationDate: dayjs(values.registrationDate).format('YYYY-MM-DD'),
      };
      onOk(formattedValues);
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Thêm đối tác mới"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Thêm"
      cancelText="Hủy"
      width={600}
    >
      <Form form={form} layout="vertical" className="mt-4">
        <Form.Item
          name="name"
          label="Tên đối tác"
          rules={[{ required: true, message: 'Vui lòng nhập tên đối tác' }]}
        >
          <Input placeholder="Nhập tên đối tác" />
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="email" label="Email">
            <Input placeholder="Nhập email" />
          </Form.Item>

          <Form.Item name="phone" label="Số điện thoại">
            <Input placeholder="Nhập số điện thoại" />
          </Form.Item>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="registrationDate" label="Ngày đăng ký">
            <DatePicker
              className="w-full"
              format="DD/MM/YYYY"
              placeholder="Chọn ngày đăng ký"
            />
          </Form.Item>

          <Form.Item name="status" label="Trạng thái" initialValue="ACTIVE">
            <Select>
              <Select.Option value="ACTIVE">Hoạt động</Select.Option>
              <Select.Option value="INACTIVE">Không hoạt động</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <Form.Item name="description" label="Mô tả">
          <Input.TextArea rows={4} placeholder="Nhập mô tả" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PartnerCreateModal;
